import { useCallback, useState } from 'react';

import { DEFAULT_PINNED_TOOLS, TOOL_SECTIONS, type NavSection } from '../config/navigation';

const KEY = 'aq.bureau.pinnedTools';

/** The stored pins, kept only if they still name a tool; the default when nothing usable is stored. */
export function parsePinned(raw: string | null): NavSection[] {
  if (raw === null) return [...DEFAULT_PINNED_TOOLS];
  try {
    const value: unknown = JSON.parse(raw);
    if (!Array.isArray(value)) return [...DEFAULT_PINNED_TOOLS];
    return TOOL_SECTIONS.filter((t) => value.includes(t));
  } catch {
    return [...DEFAULT_PINNED_TOOLS];
  }
}

function read(): NavSection[] {
  try {
    return parsePinned(localStorage.getItem(KEY));
  } catch {
    return [...DEFAULT_PINNED_TOOLS];
  }
}

/**
 * The tools pinned in the header (mock-up « Navigation »: « Épingle un outil pour le garder dans le
 * bandeau »). A per-viewer convenience, so it lives in this browser's storage — never a source of
 * truth; when the storage is unavailable the mock-up's default (Relations) applies.
 */
export function usePinnedTools() {
  const [pinned, setPinned] = useState<NavSection[]>(read);
  const toggle = useCallback((tool: NavSection) => {
    setPinned((current) => {
      const next = current.includes(tool) ? current.filter((t) => t !== tool) : TOOL_SECTIONS.filter((t) => t === tool || current.includes(t));
      try {
        localStorage.setItem(KEY, JSON.stringify(next));
      } catch {
        // Private mode or blocked storage: the pin holds for this visit only.
      }
      return next;
    });
  }, []);
  return { pinned, toggle };
}
